module.exports = __webpack_public_path__ + "static/media/nysc.0e775dbd.svg";